import React from 'react';
import { Toast, ToastProps } from '../atoms/Toast';
import './ToastContainer.css';

export interface ToastData extends Omit<ToastProps, 'onClose'> {
  id: string;
}

export interface ToastContainerProps {
  toasts: ToastData[];
  onRemoveToast: (id: string) => void;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
  maxToasts?: number;
  className?: string;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  onRemoveToast,
  position = 'top-right',
  maxToasts = 5,
  className = ''
}) => {
  // Limit the number of visible toasts
  const visibleToasts = toasts.slice(0, maxToasts);

  return (
    <div className={`toast-container toast-container--${position} ${className}`}>
      {visibleToasts.map((toast) => (
        <Toast
          key={toast.id}
          {...toast}
          onClose={onRemoveToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
